import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import TiktokPixel from 'tiktok-pixel';
import { CustomImage } from '../../../../Components/Image/Image';
import './Hotel.css';

export const Hotel = ({
  image,
  imageTitle,
  name,
  address,
  cityAndState,
  id,
  startDate,
  map,
  time,
  price,
  distance,
  loc,
}) => {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <div
      className="hotel-infos"
      onClick={() => {
        TiktokPixel.track('ClickButton', {
          content_name: 'Hotel',
          content_type: 'product',
          timestamp: new Date(),
          description: 'Clicked on a hotel from hotels page',
          query: name,
        });

        navigate(
          `/hotel/${id}/${startDate}/${loc.lat}/${loc.lng}/${params.place}/${loc.country}`
        );
      }}
    >
      <div className="hotel-distance">{distance} miles away</div>
      <CustomImage url={image} title={imageTitle} />
      <div className={`hotel-info ${map ? 'hotel-info-map' : undefined}`}>
        <div>
          <h2>{name}</h2>
          <div>
            <p style={{ lineHeight: map ? 'inherit' : 0 }}>{address}</p>
            <p>{cityAndState}</p>
          </div>
        </div>
        <div>
          <p style={{ fontSize: '13px' }}>{time}</p>
          <b style={{ fontWeight: 'bold' }}>{price}</b>
        </div>
      </div>
    </div>
  );
};
